import { useContext } from 'react';
import { PromoCodeContext } from '../../providers/PromoCodeProvider';

const usePromoCode = () => {
  return useContext(PromoCodeContext);
};

export default usePromoCode;
